const teacherPages = {
  orientation: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/orientation`,
    v1: false
  },
  addNewClass: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/add`,
    v1: false
  },
  myClasses: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/classrooms`,
    v1: false,
  },
  classroom: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}`,
    v1: false
  },
  classroomEdit: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/edit`,
    v1: false
  },
  courseContent: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/course-content`,
    v1: false,
  },
  lessonSummary: {
    getRoute: (schoolId: number, teacherId: number, lessonSummaryId: number) => `/schools/${schoolId}/teachers/${teacherId}/course-content/lessons/${lessonSummaryId}`,
    v1: false
  },
  videoHighlight: {
    getRoute: (schoolId: number, teacherId: number, lessonSummaryId: number, videoHighlightId: number) => `/schools/${schoolId}/teachers/${teacherId}/course-content/lessons/${lessonSummaryId}/${videoHighlightId}`,
    v1: false
  },
  dailBeatPlayer: {
    getRoute: (schoolId: number, teacherId: number, id: number) => `/schools/${schoolId}/teachers/${teacherId}/course-content/dailyBeats/${id}`,
    v1: false
  },
  profile: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile`,
    v1: false,
  },
  accountSettings: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile/account-settings`,
    v1: false,
  },
  updateName: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile/update-name`,
    v1: false
  },
  updatePassword: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile/update-password`,
    v1: false
  },
  deleteAccount: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile/delete-account`,
    v1: false
  },
  deleteAccountConfirm: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile/delete-account-confirm`,
    v1: false
  },
  studentDrillDown: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string, studentId: number | string) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/students/${studentId}`,
    v1: false
  },
  classroomModeLessonPlayer: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string, lessonId: number) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/lesson/${lessonId}`,
    v1: false
  },
  classroomModeDailyBeatPlayer: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string, dailyBeatId: number) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/dailyBeat/${dailyBeatId}`,
    v1: false
  },
  projectedFocusSession: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/focus`,
  },
  gradeView: {
    getRoute: (schoolId: number, teacherId: number, classroomId: number | string) => `/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/grades`,
    v1: false
  },
  teacherResources: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/resources`,
    v1: false
  },
  resourceVideo: {
    getRoute: (schoolId: number, teacherId: number, resourceVideoId: number) => `/schools/${schoolId}/teachers/${teacherId}/resources/${resourceVideoId}`,
    v1: false
  },
  resetStudentViewConfirm: {
    getRoute: (schoolId: number, teacherId: number) => `/schools/${schoolId}/teachers/${teacherId}/profile/reset-student-view-confirm`,
    v1: false
  }
}

export const defaultTeacherPage = teacherPages.myClasses

export default teacherPages
